import { Box, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { FileIcon } from '@/imports/ui/chakra/feather';

import { getHighlightValue, getOpenSearchFileUrl } from '../hitHelpers';
import { OpenSearchHit } from '../types';
import { OpenSearchText } from './OpenSearchText';

export const OpenSearchFile: React.FC<{ hit: OpenSearchHit }> = ({ hit }) => {
  const fileName =
    getHighlightValue(hit, 'file.name', '_highlightResult') ||
    hit.file?.name ||
    hit.fileName ||
    hit.name ||
    'File';

  return (
    <LinkBox
      as={Stack}
      direction="row"
      spacing="2"
      alignItems="center"
      p="2"
      bg="white"
      _hover={{ bg: 'gray.100' }}
      borderRadius="xl"
      cursor="pointer"
    >
      <FileIcon boxSize="8" />
      <Box>
        <LinkOverlay as={NextLink} href={getOpenSearchFileUrl(hit)}>
          <Text noOfLines={1} textStyle="bodyStrong">
            <OpenSearchText value={fileName} />
          </Text>
        </LinkOverlay>
        {hit.displayName && (
          <Text noOfLines={1} textStyle="compact" color="gray.700">
            {hit.displayName}
          </Text>
        )}
      </Box>
    </LinkBox>
  );
};

